import Vue from 'vue'
import Vuex from 'vuex'

import globals from './modules/globals'
import data from './modules/data'
import settings from './modules/settings'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isInitPageLoad: true,
    frontPageCases: [],

    currentCase: '',
    cloneElement: null,
  },
  mutations: {
    SET_CURRENT_CASE: (state, current) => state.currentCase = current,

    firstPageLoad: state => state.isInitPageLoad = false,
    getFrontpageCases: (state, caseElem) => state.frontPageCases.push(caseElem),
    clearFrontpageCases: state => state.frontPageCases = [],
    addCloneElement: (state, element) => state.cloneElement = element,
    removeCloneElement: state => state.cloneElement.remove(),
  },
  modules: {
    data,
    globals,
    settings,
  }
})
